import React from 'react';
import './Landing.css';

function LandingSection() {
  return (
    <div id="industry-landing">
      <div id="industry-header">
        <h1>
          Parcerias com
          o mercado
        </h1>
        <p>
          Estratégias de inovação aplicada
          em parcerias mercado/academia
        </p>
      </div>
      <div id="industry-image" />
    </div>
  );
}

export default LandingSection;
